import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const playlist = this.element.dataset.playlist

    coverflow('container').setup({
      width: '100%',
      item: 2,
      backgroundopacity: 0,
      covergap: 100,
      playlist: playlist,
      coverwidth: 250,
      coverheight: 250,
      reflectionopacity: 0,
      fixedsize: true,
      textoffset: 50
    }).on('ready', function() {
      this.on('click', function(index, link) {
        window.location.href = link;
      })
    })
  }

  disconnect() {
    coverflow('container').remove()
  }
}